<template>
  <ModalDefault modal_id="addRepliesModal"
                header="y"
                size="modal-md modal-dialog-scrollable"
                style_header=""
                :modal_header="getTranslations('expression_628')"
                :footer="new_reply.label && new_reply.text"
                :method="alertAddReplies"
                icon="bx bx-share mr-1">
    <div @click.prevent="isShowEmoji = false;" class="px-2 py-0" slot="body">
      <div>
        <div class="d-flex">
          <div class="file-upload-center cursor-default w-100"  style="align-items: center; align-self: center;">
            <div class="d-block pt-2 px-2">
              <!--Marcação-->
              <div class="col-12 px-0">
                <label class="mb-0">{{ getTranslations('expression_629') }} </label>
                <span class="">
                    <i style="font-size: .8rem" v-b-tooltip.right
                       :title="getTranslations('expression_630')"
                       class="ml-1 bx bx-info-circle"></i>
                  </span>
                <div class="input-group mb-3">
                  <input type="text" v-model="new_reply.label" class="input_forms form-control">
                </div>
              </div>
              <!--Conteúdo da mensagem-->
              <div class="col-12 px-0">
                <label class="mb-0">
                  {{ ['image/png', 'image/jpeg', 'image/jpg'].includes(new_reply.mime_type_file) ? getTranslations('expression_343') : getTranslations('expression_631') }}
                </label>
                <div class="input-group mb-0">
                  <textarea rows="4"
                            v-model="new_reply.text"
                            style="resize: none;padding-right: 40px;"
                            ref="addreplies_msg"
                            class="input_forms form-control"
                            id="addreplies_msg"
                            :maxlength="['image/png', 'image/jpeg', 'image/jpg'].includes(new_reply.mime_type_file) ? 200 : 1000"/>
                </div>
              </div>
              <div class="col-12 px-0 pb-2" style="margin-top: -25px;">
                <div class="d-flex text-right"
                     style="margin-top: -35px;
                            margin-bottom: 0px;
                            position: relative;
                            width: 53px;
                            float: right;
                            z-index: 9999;">
                  <!--// Dropdown Variáveis //-->
                  <DropdownDefault dd_id="dd_input_add_reply_1"
                                   dd_position="right"
                                   :dd_click="selectVariable"
                                   :dd_data="configs.chat_variables">
                    <div slot="dd_cta">
                      <i v-b-tooltip.top :title="getTranslations('expression_547')"
                         class="animated--grow-in bx bx-code hover_icons cursor_pointer mr-2"
                         style="font-size: 1.2rem;">
                      </i>
                    </div>
                  </DropdownDefault>
                  <i v-b-tooltip.bottom
                     :title="getTranslations('expression_298')"
                     @click.stop="showEmoji"
                     class="animated--grow-in bx bx-happy hover_icons cursor_pointer mr-2"
                     style="font-size: 1.2rem;"></i>
                </div>
                <div @click.stop="">
                  <VEmojiPicker v-if="isShowEmoji"
                                @select="selectEmoji"
                                :emojiWithBorder="false"
                                :emojisByRow="10"
                                :showSearch="false"
                                :i18n="i18n"
                                :limitFrequently="14"
                                class="custom-picker-emoji shadow animated--fade-in" />
                </div>
              </div>
              <div style="display: flex;justify-content: flex-end;width: 100%;margin-top: 3px">
                <TextCount :length="new_reply.text ? new_reply.text.length : 0" :limit="['image/png', 'image/jpeg', 'image/jpg'].includes(new_reply.mime_type_file) ? 200 : 1000"/>
              </div>

              <div class="col-12 pt-4 px-0">
                <label class="mb-0"> {{ getTranslations('expression_506') }} </label>
                <div @click.stop="" class="col-12 pt-3 px-0">
                  <input type="file" @change.stop="loadFile" id="fileHandlerRepliesNew" hidden>
                  <input type="hidden" v-model="new_reply.upload_file">
                  <div class="d-flex">
                    <div class="border shadow-sm cursor_pointer"
                         v-if="new_reply.url_file && ['image/png', 'image/jpeg', 'image/jpg'].includes(new_reply.mime_type_file)"
                         :style="`background-image: url(${new_reply.url_file})`"
                         @click.stop="changeFileReply"
                         style="width: 100%;
                                min-height: 200px;
                                background-position: center;
                                background-size: cover;
                                background-repeat: no-repeat;">
                    </div>
                    <div v-if="new_reply.url_file !== null">
                      <div class="pt-3" style="margin-left: -50px;">
                        <i v-b-tooltip.bottom
                           :title="getTranslations('expression_297')"
                           @click.stop="removeFileReply"
                           class="bg-white text-secondary shadow-sm rounded-circle py-1 px-1 bx bx-x bx-xs cursor_pointer"></i>
                      </div>
                    </div>
                  </div>
                  <div v-if="!new_reply.url_file"
                       @click.stop="changeFileReply"
                       class="bg-light border cursor_pointer py-4"
                       style="display: flex; min-height: 200px; justify-content: center; align-items: center;">
                    <div class="d-block text-center">
                      <div>
                        <i class="bx bx-upload bx-sm"></i>
                      </div>
                      <div>
                        <span class="d-block">{{ getTranslations('expression_632') }}</span>
                        <small class="d-block pt-2">
                          {{ getTranslations('expression_633') }}
                          <br>
                          {{ getTranslations('expression_634') }}
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div slot="footer" class="px-2 py-2 d-flex">
      <div>
          <span @click.stop="alertAddReplies"
                data-dismiss="modal"
                class="shadow-sm cursor_pointer animated--grow-in btn-secondary text-white py-2 px-3">
            <span class="">{{ getTranslations('expression_120') }}</span>
          </span>
      </div>
    </div>
  </ModalDefault>
</template>

<script>
import ModalDefault from "../../components/general/ModalDefault";

import {mapGetters, mapState} from "vuex";
import $ from "jquery";
import Swal from "sweetalert2";
import DropdownDefault from "../general/DropdownDefault";
import TextCount from "../general/TextCount";

export default {
  name: "ModalAddReply",
  components: {
    TextCount,
    ModalDefault,
    DropdownDefault
  },
  computed: {
    ...mapState(['channels', 'departments', 'replies']),
    ...mapGetters([
      'getDepartmentsArray',
    ]),
  },
  data() {
    return {
      dropdownClickOption: null,
      startPosition: null,
      endPosition: null,
      new_reply: {
        label: "",
        text: "",
        upload_file: null,
        file: null,
        mime_type_file: null,
        url_file: null
      },
      isShowEmoji: false,
      i18n: {
        search: 'Pesquisar...',
        categories: {
          Activity: "Atividades",
          Flags: "Bandeiras",
          Foods: "Comida",
          Frequently: "Frequentes",
          Objects: "Objetos",
          Nature: "Natureza",
          Peoples: "Pessoas",
          Symbols: "Símbolos",
          Places: "Locais"
        }
      },
    }
  },
  mounted() {

    // Recebe dados dos clique nos Dropdowns
    this.$root.$on('setClickOption', (payload) => {
      this.dropdownClickOption = payload;
    });

    $('#addRepliesModal').on('hidden.bs.modal', () => {
      this.new_reply = {
        label: "",
        text: "",
        upload_file: null,
        file: null,
        mime_type_file: null,
        url_file: null
      },
      this.isShowEmoji = false;
    })
  },
  methods: {
    verifyStringReply() {
      // this.replies.reply && this.replies.reply.text &&
      if(this.new_reply && this.new_reply.text && this.new_reply.text.length > 200) {
        const field_array = this.new_reply.text.split('');
        while(field_array.length > 200) {
          field_array.pop()
        }
        this.new_reply.text = field_array.join('')
      }
    },
    alertAddReplies(){
      this.new_reply.channel_id = this.channels.channel.id
      this.new_reply.department_id = this.channels.edit.department_id
      // TODO: Remover a obrigatoriedade do campo name do backend
      this.new_reply.name = this.new_reply.label
      this.$store.dispatch("addReply", this.new_reply)
      $('#addRepliesModal').modal('hide')
    },
    showEmoji() {
      this.isShowEmoji = !this.isShowEmoji;
    },
    selectEmoji(a) {
      this.startPosition = this.$refs.addreplies_msg.selectionStart;
      this.endPosition = this.$refs.addreplies_msg.selectionEnd;
      this.$refs.addreplies_msg.setSelectionRange(this.startPosition, this.endPosition);
      const text = this.$refs.addreplies_msg.value;
      if(text === null) {
        this.new_reply.text = a.data
      } else {
        const textBefore = text.substring(0, this.startPosition);
        const textAfter = text.substring(this.endPosition, text.length);
        this.new_reply.text = `${textBefore}${a.data}${textAfter}`
        this.startPosition += a.data.length;
      }
      setTimeout(() => {
        this.$refs.addreplies_msg.setSelectionRange(this.startPosition, this.startPosition);
        this.$refs.addreplies_msg.focus()
      }, 100)
    },
    loadFile(){
      const files = document.getElementById('fileHandlerRepliesNew')
      if(files.files && files.files[0]){
        const file = files.files[0]
        if (['image/png', 'image/jpeg', 'image/jpg'].includes(file.type)) {
          const size = (file.size / 1024) / 1024
          if (size <= 5) {
            const FR = new FileReader();
            FR.addEventListener('load', (e) => {
              this.new_reply.upload_file = e.target.result
              this.new_reply.url_file = e.target.result
              this.new_reply.mime_type_file = file.type
            })
            FR.readAsDataURL(file)
          } else {
            Swal.fire(
              `${ this.getTranslations('expression_683') }`,
              `${this.getTranslations('expression_681')} <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
              'warning'
            )
          }
          this.verifyStringReply()
        } else {
          Swal.fire(
            `${ this.getTranslations('expression_683') }`,
            `${ this.getTranslations('expression_684') } <br/> <small>${this.getTranslations('expression_892')}</small> <br/> <small>${this.getTranslations('expression_682')} ${file.name}</small>`,
            'warning'
          )
        }
      }
      files.value = ''
    },
    removeFileReply() {
      this.new_reply.upload_file = null
      this.new_reply.file = null
      this.new_reply.mime_type_file = null
      this.new_reply.url_file = null
    },
    changeFileReply(){
      $('#fileHandlerRepliesNew').click()
    },
    selectVariable() {
      this.startPosition = this.$refs.addreplies_msg.selectionStart;
      this.endPosition = this.$refs.addreplies_msg.selectionEnd;
      this.$refs.addreplies_msg.setSelectionRange(this.startPosition, this.endPosition);
      const text = this.$refs.addreplies_msg.value;
      if(text === null) {
        this.new_reply.text = this.dropdownClickOption.code
      } else {
        const textBefore = text.substring(0, this.startPosition);
        const textAfter = text.substring(this.endPosition, text.length);
        this.new_reply.text = `${textBefore}${this.dropdownClickOption.code}${textAfter}`
        this.startPosition += this.dropdownClickOption.code.length;
      }
      setTimeout(() => {
        this.$refs.addreplies_msg.setSelectionRange(this.startPosition, this.startPosition);
        this.$refs.addreplies_msg.focus()
      }, 100)
    },
  },
}
</script>

<style scoped>

</style>
<style lang="scss">
.custom-picker-emoji {
  //position: absolute;
  min-width: 100%;
  //margin-left: -16px;
  max-height: 195px;
  //top: 537px;
  border-radius: 0 !important;
}

#Categories {
  position: absolute;
  //min-width: 99%;
  max-width: 98.8%;
}
#Emojis {
  top: 35px;
  //position: relative;
}
.container-emoji {
  padding-top: 35px;
  padding-bottom: 35px;
  height: 195px!important;
}
#EmojiPicker {
  display: block;
}
</style>
